module.exports = "<mdb-carousel class=\"carousel slide\" [animation]=\"'slide'\" [interval]=\"slideSpeed\">\n    <mdb-slide *ngFor=\"let slide of slides\">\n        <img class=\"d-block\" src={{slide}} alt=\"First slide\">\n    </mdb-slide>\n</mdb-carousel>"


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/welcome/carousel/carousel.component.html
// module id = 410
// module chunks = 1